var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"mb-4 mr-4",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("mdi-arrow-left")])
}
var staticRenderFns = []

export { render, staticRenderFns }